module.exports = __webpack_public_path__ + "static/media/radiance.85f9c65d.svg";